export let featured_talks = function () {
  $('.featured-talks-slider').flickity({
    wrapAround: true,
    pageDots: true,
  });
}